module.exports = __webpack_public_path__ + "static/media/logo-solid.5a3651b9.png";